import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createDateHasAllTimeCol,
  createDateRangeCol,
  createDetailButtonColV2,
  createIdCol,
  createImagePreviewCol,
  createIndexCol,
  createStatusBadgeCol,
  createTypoCol,
  createViewableCol,
} from '@/src/helpers/agColumnHelper';
import { CreditTemplateDto } from '@/src/models/CreditTemplateDto';
import { formatter } from '@/src/utils/formatter';
import { UNIT_STRINGS } from '@/src/constants/unit';
import Button from '@/src/components/atom/Button';

export const ChallengeParticipantListColumn = (
  onDetailClick: (customerId: number) => void,
): ColDef[] => [
  createIndexCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '마지막 참여 일시',
  }),
  createTypoCol({
    field: 'nick',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'name',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.name || '-',
    headerName: '이름',
  }),
  createTypoCol({
    field: 'phone',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.phone ? formatter.PHONE(data?.customer?.phone) : '-',
    headerName: '핸드폰 번호',
  }),
  createStatusBadgeCol({
    field: 'isSuccess',
    type: 'isSuccess',
    size: 'sm',
    headerName: '처리',
  }),
  createImagePreviewCol({
    field: 'challengeImage',
    width: 40,
    height: 40,
    isPreviewRatioFixed: false,
    valueFormatter: params => {
      return params.data?.challengeImage?.bufferFullUrl || '';
    },
    headerName: '참여 사진',
  }),
  {
    field: 'detail',
    lockPosition: 'right',
    pinned: 'right',
    headerName: '조회',
    headerClass: 'ag-right-aligned-cell',
    width: 129,
    minWidth: 129,
    maxWidth: 129,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    cellRenderer: ({ data }: ICellRendererParams) => {
      return (
        <Button
          buttonSize="xSmall"
          buttonColor="outline"
          onClick={() => onDetailClick(data?.customer?.id as number)}
        >
          상세보기
        </Button>
      );
    },
  },
];

export const challengeListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateRangeCol({
    field: 'startedAt',
    keys: ['startedAt', 'endedAt'],
    size: 'lg',
    headerName: '참여 기간',
  }),
  createViewableCol({
    field: 'isExposed',
    size: 'sm',
    headerName: '노출 여부',
  }),
  createStatusBadgeCol({
    field: 'priorityDisplayYn',
    type: 'isApplied',
    size: 'sm',
    headerName: '우선 노출 여부',
  }),
  createTypoCol({
    field: 'title',
    size: 'lg',
    headerName: '제목',
  }),
  createTypoCol({
    field: 'participantsCnt',
    size: 'sm',
    valueFormatter: ({ value }: { value: number }) =>
      `${value?.toLocaleString() || '0'}명`,
    headerName: '참여자 수',
  }),
  createTypoCol({
    field: 'creditTemplate',
    size: 'sm',
    valueFormatter: ({ value }: { value: CreditTemplateDto }) =>
      `${value?.credit?.toLocaleString() || '0'}`,
    headerName: `지급 크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];
